export { default } from "./TeachersTabResourceSelectorCard";
